import MidiEffect from './MidiEffect.js';
import StepData from 'pattern/StepData.js';
import MidiTrigger from './MidiTrigger.js';
import {getTriggerTimes} from 'keyboard/TriggerTimeHelper.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import Resolution from 'engine/Resolution.js';
import {UP, DOWN, UP_DOWN, DOWN_UP} from './constants.js';
import ChordRhythmEffect from './ChordRhythmEffect.js';
import Tone from 'tone';
const TIME_32N = new Tone.Time('32n');

class ChordSculptorEffect extends MidiEffect {
    constructor(track) {
        super('Chord Sculptor', track);
        this.liveTriggers = [];

        this.linesParameter =  new AbstractParameter(
            'lines', this, (o, x) => this.lines = x,
            {
                defaultValue: [],
                min: [],
                max: [],
                unit: ''
            });

        this.registerParameter(this.linesParameter);

        this.effects  = [];
        this.rawLines = [];
    }

    clear() {
        this.effects.forEach(e => e.clear());
    }

    onNewStep() {
        this.effects.forEach(e => e.onNewStep());
    }

    removeNote(note, sliceNumber, skip=!this.gated) {
        this.effects.forEach(e => e.removeNote(note, sliceNumber, skip));
    }

    // need to call addNote when live triggering
    isRealTime() {
        return false;
    }

    set lines(lines) {
        this.rawLines = lines;

        let effects = [];
        for (let i in lines) {
            let {x1, y1, x2, y2, brightness} = lines[i];
            let repeats = Math.abs(Math.ceil(16 * (x2 - x1)));
            let evenDelayTime = y1 * 8;
            let oddDelayTime = y2 * 8;
            let durationFactor = 4* (x1 + x2) / 2;
            let velocity = brightness || 1;

            let effect = new ChordRhythmEffect(this.track);
            effect.evenDelayTimeParameter.set(evenDelayTime);
            effect.oddDelayTimeParameter.set(oddDelayTime);
            effect.repeatsParameter.set(repeats);
            effect.durationFactorParameter.set(durationFactor);
            effect.velocityParameter.set(velocity);
            effects.push(effect);
        }

        this.effects = effects;
    }

    removeNote(note, sliceNumber, skip=!this.gated) {
        this.effects.forEach(
            e => e.removeNote(note, sliceNumber, skip));
    }

    input(trigger, isLive=false) {
        this.effects.forEach(
            e => e.input(trigger, isLive));
    }

    output(time, stepNumber, actualStepNumber) {
        let triggers = [];
        for (let i in this.effects) {
            triggers = [... triggers, ... this.effects[i].output(time, stepNumber, actualStepNumber)];
        }
        return triggers;
    }

    getCopy(track, ignoreId=true) {
        let copy = new ChordSculptorEffect(track);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default ChordSculptorEffect;
